import { FilterDropdown } from "@repo/ui";

import type { DropDownProps } from ".";

interface Props extends DropDownProps {
	isMulti?: boolean;
	allOption?: boolean;
}

export function MarketersDropdown(props: Props) {
	const { allOption = true } = props;

	return (
		<FilterDropdown
			{...props}
			id="marketerIds"
			allOption={allOption}
			values={props.options?.data ?? []}
			objectName="Marketers"
			fullLength
			isMulti={props.isMulti ?? true}
		/>
	);
}
